"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var dot_case_1 = require("dot-case");
function snakeCase(input, options) {
    if (options === void 0) { options = {}; }
    return dot_case_1.dotCase(input, tslib_1.__assign({ delimiter: "_" }, options));
}
exports.snakeCase = snakeCase;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/snake-case/dist/index.js
// module id = 1241
// module chunks = 0